<template>
  <v-app>
    <v-main style="padding: 0px 0px 0px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { updateMeta } from './utils/meta'

export default {
  name: 'App',

  data: () => ({
    //
  }),

  watch: {
    '$i18n.locale'() {
      updateMeta(this.$route, this.$route.query.lang || 'tw')
    }
  }
};
</script>
